<template>
  <div>
    <CCardBody class="py-0 pl-2 pr-0">
      <table class="table mb-0">
        <tbody>
          <div
            class="custom-width-total"
            v-for="(r, index) in ubicaciones.filter(
              ubi => ubi.payload.pertenece_id == ubicacionPadre
            )"
            :key="index"
          >
            <tr class="custom-width-total">
              <td
                @click="toggleSubUbicaciones(index)"
                :class="
                  `${
                    ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
                class="custom-width"
              >
                <span>
                  <CIcon
                    v-if="
                      ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                        .length > 0
                    "
                    name="cil-chevron-circle-down-alt"
                  />
                </span>
                {{ r.payload.nombre }}
              </td>
              <td
                @click="toggleSubUbicaciones(index)"
                class="custom-width"
                :class="
                  `${
                    ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                {{
                  r.payload.cultivo_id == 0
                    ? ""
                    : getCultivo(r.payload.cultivo_id)
                }}
              </td>
              <td class="custom-width">
                  <CSwitch
                    v-if="isLeaf(r.id)"
                    :checked="!r.payload.suspendido"
                    @update:checked="() => toggleSuspendido(r)"
                    class="mx-1"
                    color="primary"
                    variant="3d"
                  />
              </td>
              <td class="custom-width5">
                <p-check
                  class="p-svg p-curve"
                  name="check"
                  color="success"
                  v-model="r.selected"
                >
                  <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style="stroke: white;fill:white"
                    />
                  </svg>
                  Imprimir
                </p-check>
              </td>

              <!-- <td class="custom-width5">
                <CButton color="info" @click="printNanoid(r)" square size="sm">Imprimir</CButton>
              </td>-->
              <td class="custom-width5">
                <router-link
                  :to="{ name: 'EditarUbicacion', params: { id: r.id } }"
                >
                  <CButton color="success" square size="sm">Editar</CButton>
                </router-link>
              </td>
              <td class="custom-width5">
                <CButton
                  :disabled="
                    ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                      .length > 0
                      ? true
                      : false
                  "
                  color="danger"
                  square
                  size="sm"
                  @click="toggleCancel(index, r)"
                  >Borrar</CButton
                >
              </td>
            </tr>
            <tr
              v-if="
                ubicaciones.filter(p => p.payload.pertenece_id == r.id).length >
                  0
              "
            >
              <td class="py-0 pl-2 pr-0" colspan="5">
                <CCollapse
                  :show="subDetails.includes(index)"
                  class="m-0 custom-width-total"
                >
                  <table-collapse
                    :isLeaf="isLeaf"
                    :toggleSuspendido="toggleSuspendido"
                    @click-cancel="toggleCancel"
                    @click-print="printNanoid"
                    :ubicacionPadre="r.id"
                    :cultivos="cultivos"
                    :ubicaciones="ubicaciones"
                  ></table-collapse>
                </CCollapse>
              </td>
            </tr>
          </div>
        </tbody>
      </table>
    </CCardBody>
  </div>
</template>

<script>
import PrettyCheck from "pretty-checkbox-vue/check";

export default {
  name: "TableCollapse",

  props: {
    ubicaciones: {
      type: Array
    },
    cultivos: {
      type: Array
    },
    ubicacionPadre: {
      type: Number
    },
    isLeaf: {
      type: Function,
      default: ()=>{}
    },
    toggleSuspendido: {
      type: Function,
      default: ()=>{}
    },
  },

  data() {
    return {
      subDetails: [],
      itemModal: { id: "", name: "", index: "" }
    };
  },

  components: {
    TableCollapse: () => import("./TableCollapse.vue"),
    "p-check": PrettyCheck
  },

  methods: {
    toggleCancel(index, item) {
      this.$emit("click-cancel", index, item);
    },
    printNanoid(ubicacion) {
      this.$emit("click-print", ubicacion);
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },

    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.find(
        cultivo => cultivo.id == cultivo_id
      );
      const variedad = cultivoActual?.payload?.variedad || ''
      return cultivoActual ? cultivoActual?.payload?.nombre + ' ' + variedad : "";
    },
    toggleSubUbicaciones(index) {
      const positionSub = this.subDetails.indexOf(index);
      positionSub !== -1
        ? this.subDetails.splice(positionSub, 1)
        : this.subDetails.push(index);
    }
  }
};
</script>

<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 50%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
